import * as yup from "yup";

import * as RHFWishListValidationRules from "@/utils/validation/schemas/wishlist.RHF";

export const WishlistCreateListFormValidationSchema = yup.object({
    name: RHFWishListValidationRules.wishlistName
});

export type WishlistCreateListFormValues = yup.InferType<
    typeof WishlistCreateListFormValidationSchema
>;
